import React from "react";
import {
  Box,
  Button,
  Typography,
  Divider,
  Grid2,
  Card,
  CardContent,
} from "@mui/material";
import { Star } from "@mui/icons-material";
import { useNavigate } from "react-router";
import {ReactComponent as AvatarImage } from "../../assets/logos/profileAvatar.svg";
import {ReactComponent as EditImage } from "../../assets/logos/editIconWhite.svg";
import {ReactComponent as RequestImage } from "../../assets/requests.svg";
import {ReactComponent as DeliveryImage } from "../../assets/deliveries.svg";
import { setStorageValue } from "../../utils/helper";

const UserProfile = ({ userData }) => {
  const navigate = useNavigate();

  const countryCode = userData.countryCode.startsWith("+")
    ? userData.countryCode
    : `+${userData.countryCode}`;
  const formattedNumber = `${countryCode} (${userData.phoneNumber})`;

  const handleNavigateDeliveries = () => {
    navigate("/MyDelivery");
    setStorageValue("menuName", "My Delivery");
  };

  const handleNavigateRequests = () => {
    navigate("/MyRequest");
    setStorageValue("menuName", "My Request");
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Profile
      </Typography>
      <Card
        sx={{
          width: "100%",
          border: "1px solid #E6EDFF",
          borderRadius: 2,
          paddingLeft: "5px",
          marginTop: "1rem",
          boxShadow: "none !important",
        }}
      >
        <CardContent>
          <Grid2 container spacing={2} 
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
          }}>
            <Grid2 item sx={{ display: "flex", justifyContent: "flex-start", gap:2, alignItems: "center", width: "55%"}}>
              <AvatarImage width={50} height={50} style={{ marginTop: "9px" }} />
              <Box>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  lineHeight="30px"
                >{`${userData.firstName} ${userData.lastName}`}</Typography>
                <Box display="flex" alignItems="center">
                  {[...Array(Math.floor(userData.rating))].map((_, i) => (
                    <Star key={i} sx={{ color: "#FFC107" }} />
                  ))}
                  {[...Array(5 - Math.floor(userData.rating))].map((_, i) => (
                    <Star
                      key={i + Math.floor(userData.rating)}
                      sx={{ color: "#E0E0E0" }}
                    />
                  ))}
                  <Typography variant="body1" fontWeight={800} ml={1}>
                    {userData.rating.toFixed(1)}
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Box display="flex" gap={2}>
              <Button
                className="open-filter-btn filter-button"
                type="button"
                onClick={handleNavigateDeliveries}
                sx={{ minWidth: 100, height: 34 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <DeliveryImage />
                  <span
                    style={{
                      color: "#475467",
                      fontSize: "16px",
                      fontWeight: "500",
                      paddingLeft: "6px"
                    }}
                  >
                    Deliveries
                  </span>
                  <strong
                    variant="body1"
                    style={{
                      marginLeft: 15,
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "black",
                    }}
                  >
                    {userData.deliveredCount}
                  </strong>
                </Box>
              </Button>
              <Button
                className="open-filter-btn filter-button"
                type="button"
                onClick={handleNavigateRequests}
                sx={{ minWidth: 100, height: "34px" }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <RequestImage />
                  <span
                    style={{
                      color: "#475467",
                      fontSize: "16px",
                      fontWeight: "500",
                      paddingLeft: "6px"
                    }}
                  >
                    Requests
                  </span>
                  <strong
                    style={{
                      marginLeft: 15,
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "black",
                    }}
                  >
                    {userData.requestedCount}
                  </strong>
                </Box>
              </Button>
              <Button
                onClick={() => navigate("/editProfile")}
                variant="contained"
                color="primary"
                sx={{
                  gap: "7px",
                  height: "34px",
                  textTransform: "capitalize",
                  background: "#0C68F4",
                  borderRadius: "8px",
                }}
              >
                <EditImage />
                Edit
              </Button>
            </Box>
          </Grid2>
          <Divider sx={{ my: 2 }} />
          <Grid2 container spacing={2}>
            <Grid2 item xs={6} spacing={2} className="second-grid-column first-grid-column">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                Phone
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {formattedNumber}
              </Typography>
            </Grid2>
            <Grid2 item xs={6} spacing={2} className="second-grid-column">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                Email
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {userData.email}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2 item xs={6} spacing={2} className="second-grid-column first-grid-column padding-class">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                Address
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600"}}
              >
                {userData.address.street}
              </Typography>
            </Grid2>
            <Grid2 item xs={6} spacing={2} className="second-grid-column padding-class">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                State
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {userData.address.state}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2 item xs={6} spacing={2} className="second-grid-column first-grid-column padding-class">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                City
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {userData.address.city}
              </Typography>
            </Grid2>
            <Grid2 item xs={6} spacing={2} className="second-grid-column padding-class">
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#475467" }}
              >
                Zipcode
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {userData.address.zipCode}
              </Typography>
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserProfile;
